<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">Reversión de Estado</label>
      </header>
      <form [formGroup]="formDatos" (ngSubmit)="getRnt()">
        <div class="form-group">
          <label class="small text-secondary" for="codigo">{{ labelText }}</label>
          <div class="row">
              <select class="col-6 custom-select reversion-select" formControlName="tipo_filtro" (change)="setSelectedFilter()">
                 <option [ngValue]="1">RNT</option>
                 <option [ngValue]="2">Radicación</option>
               </select>
              <input formControlName="codigo" type="text" class="col-6 form-control form-control-sm reversion-input">
          </div>

        </div>

        <div class="form-row mt-5">
          <button class="btn btn-primary m-auto " [disabled]="!formDatos.valid" type="submit">Buscar</button>
        </div>
      </form>
    </section>
    <section class="col-9 p-4 mt-5 mb-5" *ngIf="datosRnt; else no_data">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Solicitud para reversar</label>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4 col-lg-2">
          <label class="small mb-0">Número RNT</label>
          <p><strong>{{datosRnt.codigo_rnt}}</strong></p>
        </div>
        <div class="col-md-4 col-lg-4">
          <label class="small mb-0">Establecimiento</label>
          <p><strong>{{datosRnt.razon_social}}</strong></p>
        </div>
        <div class="col-md-4 col-lg-2">
          <label class="small mb-0">Estado RNT</label>
          <p><strong>{{datosRnt.descripcion_estado_rnt}}</strong></p>
        </div>
        <div class="col-md-4 col-lg-2">
          <label class="small mb-0">Tipo solicitud</label>
          <p><strong>{{datosRnt.tipo_solicitud}}</strong></p>
        </div>
        <div class="col-md-4 col-lg-2">
          <label class="small mb-0">Estado solicitud</label>
          <p><strong>{{datosRnt.estado_solicitud}}</strong></p>
        </div>
        <div class="col-12 mt-1 text-center">
          <button class="btn btn-primary mt-4" [disabled]="!datosRnt.estado_valido" (click)="reversarEstado()">Reversar Estado</button>
        </div>
      </div>
    </section>
    <ng-template #no_data>
      <section class="col-9 p-4 mt-5 mb-5">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img class="img-fluid mb-4" src="../../../../../../../assets/images/sin_establecimiento.png" />
            <figcaption>
              <label class="h3">No hay información</label>
            </figcaption>
          </figure>
        </header>
      </section>
    </ng-template>
  </article>
</main>
